import React from 'react';
import type { FieldProps } from '../types';

/**
 * YesNoField Component
 *
 * Renders a binary yes/no choice (toggle or radio buttons).
 */
export const YesNoField: React.FC<FieldProps> = ({
  element,
  value,
  onChange,
  onBlur,
  error,
  disabled,
  theme,
}) => {
  const properties = element.properties;
  const normalizedValue = value;
  const isYes =
    normalizedValue === true ||
    normalizedValue === 'yes' ||
    normalizedValue === 1 ||
    normalizedValue === '1';
  const isNo =
    normalizedValue === false ||
    normalizedValue === 'no' ||
    normalizedValue === 0 ||
    normalizedValue === '0';

  return (
    <div className="mediform-field mediform-yesno-field">
      {properties?.label && (
        <div className="mediform-field-label">
          {properties.label}
          {properties.required && <span className="mediform-required"> *</span>}
        </div>
      )}

      <div className="mediform-yesno-group" role="radiogroup" aria-label={properties?.label}>
        <label
          htmlFor={`${element.id}-yes`}
          className={`mediform-yesno-option ${isYes ? 'mediform-yesno-selected' : ''}`}
        >
          <input
            type="radio"
            id={`${element.id}-yes`}
            name={element.id}
            value="yes"
            checked={isYes}
            onChange={() => onChange(true)}
            onBlur={onBlur}
            disabled={disabled}
            required={properties?.required}
            className="mediform-radio-input"
          />
          <span className="mediform-yesno-label">Yes</span>
        </label>

        <label
          htmlFor={`${element.id}-no`}
          className={`mediform-yesno-option ${isNo ? 'mediform-yesno-selected' : ''}`}
        >
          <input
            type="radio"
            id={`${element.id}-no`}
            name={element.id}
            value="no"
            checked={isNo}
            onChange={() => onChange(false)}
            onBlur={onBlur}
            disabled={disabled}
            required={properties?.required}
            className="mediform-radio-input"
          />
          <span className="mediform-yesno-label">No</span>
        </label>
      </div>

      {error && (
        <div className="mediform-field-error" style={{ color: theme?.colors?.error }}>
          {error}
        </div>
      )}
    </div>
  );
};

export default YesNoField;
